<template>
  <div>
    <v-container fluid class="pa-0 pb-8">
      <v-container class="container-custom">
        <Breadcrumbs
          :title="'Nuevo título'"
          :description="'Crear un nuevo título'"
        ></Breadcrumbs>
        <template>
          <v-row justify="center">
            <v-col class="viewSpaces" sm="12">
              <OutlinedCard :title="'Titulación'" class="mb-6">
                <v-row>
                  <v-col sm="3" class="py-2">
                    <v-text-field
                      :error-messages="
                        $v.code.$anyDirty && $v.code.$anyError
                          ? !$v.code.required
                            ? 'Ingresa el legajo del alumno'
                            : 'Error en el legajo'
                          : ''
                      "
                      :loading="loadingCode"
                      v-model.trim="$v.code.$model"
                      @blur="validateCode"
                      :label="'Legajo *'"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col sm="3" class="py-2">
                    <v-select
                      outlined
                      :items="academicDegrees"
                      item-text="description"
                      item-value="id"
                      return-object
                      :label="`Título*`"
                      @change="onChangeTitle"
                      v-model="selectedDegree"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="6" class="py-2">
                    <v-text-field
                      :error-messages="
                        $v.name.$anyDirty && $v.name.$anyError
                          ? !$v.name.required
                            ? 'Ingresa el nombre del alumno'
                            : 'Error en el nombre del alumno'
                          : ''
                      "
                      :loading="loadingCode"
                      v-model.trim="$v.name.$model"
                      :label="`Nombre *`"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col sm="3" class="py-2">
                    <v-text-field
                      :error-messages="
                        $v.note.$anyDirty && $v.note.$anyError
                          ? !$v.note.required
                            ? 'Ingrese nota final'
                            : 'Nota final no valida'
                          : ''
                      "
                      v-model.trim="$v.note.$model"
                      :label="'Nota final *'"
                      outlined
                      @keypress="$validateDecimalInputNumber($event, $v.note.$model, 10)"
                      @blur="$v.note.$touch()"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12" class="py-2">
                    <v-textarea
                      outlined
                      :label="'Descripción *'"
                      @blur="$v.description.$touch()"
                      v-model="$v.description.$model"
                      :disabled="true"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="3" class="py-2">
                    <v-text-field
                      v-model.trim="$v.regNumber.$model"
                      :label="'Nro registro'"
                      outlined
                      v-mask="'####################'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </OutlinedCard>
              <div class="d-flex justify-end">
                <Button
                  white
                  :text="$t('actions.cancel')"
                  @clicked="$router.replace('/academic/titles')"
                  @end="resetButtonValues()"
                  class="mr-4"
                ></Button>

                <Button
                  :loading="createButton.loading"
                  :success="createButton.success"
                  :error="createButton.error"
                  :text="$t('actions.create')"
                  :successText="$t('actions.created')"
                  :errorText="'Error'"
                  :disabled="!canCreate"
                  @end="resetButtonValues()"
                  @clicked="createTitle"
                ></Button>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import OutlinedCard from '@/components/OutlinedCard/OutlinedCard';
import Button from '@/components/Button/Button';
import { $student, $degrees } from '../Services';
import { required, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';

export default {
  name: 'TitlesCreate',
  components: {
    Breadcrumbs,
    OutlinedCard,
    Button,
  },
  data() {
    return {
      paginationLimit: 100,
      loadingCode: false,
      codeUnique: null,
      createButton: {
        loading: false,
        success: false,
        error: false,
      },
      code: null,
      academicDegrees: [],
      name: null,
      note: null,
      description: null,
      regNumber: null,
      selectedDegree: null,
      studentCreerData: {
        career: {
          degree: null,
        },
        name: null,
        lastname: null,
      },
    };
  },
  validations: {
    name: {
      required,
      maxLength: maxLength(75),
    },
    academicDegrees: { required },
    code: {
      required,
      unique() {
        return this.codeUnique !== false;
      },
    },
    note: {
      required,
      minValue: minValue(0),
      maxValue: maxValue(10),
    },
    description: { required },
    regNumber: {},
    formValid: [
      'name',
      'code',
      'description',
      'note',
      'academicDegrees',
      'regNumber',
    ],
  },
  computed: {
    canCreate() {
      return this.selectedDegree && this.name && this.note && this.code;
    },
  },
  methods: {
    async validateCode() {
      this.$v.code.$touch();
      if (this.$v.code.$model) {
        this.loadingCode = true;
        try {
          const response = await $student.getStudentRecord(this.code);
          this.studentCreerData = response.data;
          this.$v.name.$model = `${this.studentCreerData.name} ${this.studentCreerData.lastname}`;
          this.$v.note.$model = this.studentCreerData.career.grade;
          this.$v.description.$model = this.studentCreerData.career.description;
          this.selectedDegree = this.academicDegrees.filter(
            (item) => this.studentCreerData.career.degree == item.id
          );
          this.loadingCode = false;
          this.$nextTick(() => {});
        } catch (error) {
          this.codeUnique = null;
          throw error;
        } finally {
          this.$v.code.$touch();
        }
      }
    },
    onChangeTitle(title) {
      this.$v.description.$model = title.description;
      this.selectedDegree = title.id;
    },
    async createTitle() {
      this.createButton.loading = true;

      const currentDate = new Date();
      const formattedDate = currentDate.toISOString();

      const newTitle = {
        status: 1,
        statusDate: formattedDate,
        registry: this.regNumber,
        studentName: this.name,
        grade: parseFloat(this.note),
        titleId: this.selectedDegree,
        url: null,
        studentRecordId: this.code,
        description: this.description,
      };

      try {
        await $student.createStudentTitle(newTitle);
        this.createButton.loading = false;
        this.$store.dispatch('commons/openPopUp', {
          title: 'Título creado con éxito',
          actionPrimary: {
            text: 'Aceptar',
            callback() {},
          },
          icon: { color: 'success', name: 'mdi-check' },
          color: 'primary',
        });
        this.clearData();
      } catch {
        this.createButton.loading = false;
        this.$store.dispatch('commons/openPopUp', {
          title: 'Error al crear el título del estudiante',
          actionPrimary: {
            text: 'Aceptar',
            callback() {},
          },
          icon: { color: 'error', name: 'mdi-alert' },
          color: 'primary',
        });
      }
    },
    clearData() {
      this.resetButtonValues();
      this.$v.$reset();
      this.note = null;
      this.loadingCode = false;
      this.codeUnique = null;
      this.name = null;
      this.selectedDegree = [];
      this.code = null;
      this.description = null;
      this.selectedSubjects = [];
      this.subjectsAdded = [];
    },
    resetButtonValues() {
      this.createButton.loading = false;
      this.createButton.success = false;
      this.createButton.error = false;
    },
    async getAcademicDegrees() {
      const degrees = await $degrees.find(null, null, {
        params: { page: 0, length: 500 },
      });
      this.academicDegrees = degrees.data.content;
    },
  },
  watch: {
    'studentCreerData': function (val) {
      this.selectedDegree = Number(val.career.degree);
    },
  },
  mounted() {
    this.getAcademicDegrees();
  },
};
</script>